module.exports = __webpack_public_path__ + "static/media/icon-modal-arrow-left-dark.084117ea.svg";